import { useCallback } from 'react';
import { useClient } from 'urql';

import fetchQuery from '@/helper/data-op/fetchQuery';
import useDefaultErrorSnackbar from '@/hooks/useDefaultErrorSnackbar';
import { ContentEntity } from '@/types/schema';

import {
  FetchIsPublishableDocument,
  FetchIsPublishableQuery,
} from '../../graphql/queries/generated/fetchIsPublishable';

export default function useIsPublishable(contentId: string) {
  const client = useClient();
  const { showDefaultErrorSnackbar } = useDefaultErrorSnackbar();

  const fetchIsPublishable = useCallback(async () => {
    const { error, data } = await fetchQuery<FetchIsPublishableQuery>(
      client,
      FetchIsPublishableDocument,
      {
        filters: {
          id: contentId,
        },
      },
      {},
    );

    if (error) {
      showDefaultErrorSnackbar();

      return;
    }

    const content = data?.content as ContentEntity;

    return {
      publishable: content.publishable,
      allowMinorVersionPublish: content.allowMinorVersionPublish,
    };
  }, [client, contentId, showDefaultErrorSnackbar]);

  return {
    fetchIsPublishable,
  };
}
